import { render } from "./StandardV2BannerCarousel.vue?vue&type=template&id=22d992ec&scoped=true"
import script from "./StandardV2BannerCarousel.vue?vue&type=script&lang=js"
export * from "./StandardV2BannerCarousel.vue?vue&type=script&lang=js"

import "./StandardV2BannerCarousel.vue?vue&type=style&index=0&id=22d992ec&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d992ec"]])

export default __exports__